import React from 'react';
import styles from './AccordionHeader.module.scss';
import clsx from 'clsx';
import SortArrow from 'assets/icons/sort-arrow.svg?react';
import { UseTranslationResponse } from 'react-i18next';
import { TranslationKeys } from '@excalidraw/excalidraw/types/i18n';

type OwnProps<T> = {
  sortBy: string | null;
  desc: boolean;
  i18n: UseTranslationResponse<'translation', ''>;
  columnsOfOuterTable: {
    translateKey: T;
    serverKey: string;
    width: number | string;
    classname?: string;
    isSortingTurnedOff?: boolean;
  }[];
  hoveredHeader: string | null;
  changeSortTable: (key: string) => void;
  setHoveredHeader: (value: string | null) => void;
  containerClassname?: string;
};

export const AccordionHeader = <T,>(props: OwnProps<T>) => {
  const {
    columnsOfOuterTable,
    changeSortTable,
    sortBy,
    i18n,
    setHoveredHeader,
    hoveredHeader,
    desc,
    containerClassname,
  } = props;

  return (
    <div className={clsx(styles.headerContainer, containerClassname)}>
      {columnsOfOuterTable.map((column, index) => {
        const wasSortedByThisColumn = sortBy === column.serverKey;
        const isDescSorting = wasSortedByThisColumn && desc;
        const isSortingEnabled = !!(
          column.serverKey && !column.isSortingTurnedOff
        );

        const wasHoveredThisColumn =
          hoveredHeader === column.serverKey && isSortingEnabled;

        return (
          <div
            data-test-id={column.translateKey}
            key={column.translateKey as string}
            style={{ width: column.width }}
            className={clsx(
              styles.headerTitle,
              styles.paddingLeftRight16,
              isSortingEnabled && styles.pointer,
              wasSortedByThisColumn && styles.headerTitleActive,
              styles.rowContainerSorting,
              column.classname,
            )}
            onClick={() => {
              if (isSortingEnabled) {
                changeSortTable(column.serverKey);
              }
            }}
            onMouseEnter={() =>
              column.serverKey ? setHoveredHeader(column.serverKey) : null
            }
            onMouseLeave={() => setHoveredHeader(null)}
          >
            <div>{i18n.t(column.translateKey as TranslationKeys)}</div>
            <div className={styles.height20}>
              <SortArrow
                className={clsx(
                  !isDescSorting && styles.rotate180,
                  wasHoveredThisColumn &&
                    !wasSortedByThisColumn &&
                    styles.sortHover,
                  !wasHoveredThisColumn &&
                    !wasSortedByThisColumn &&
                    styles.displayNone,
                )}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
